import { render, staticRenderFns } from "./series_edit.vue?vue&type=template&id=57cbb8d9&scoped=true"
import script from "./series_edit.vue?vue&type=script&lang=js"
export * from "./series_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cbb8d9",
  null
  
)

export default component.exports